import { z } from "zod";

// ── Glossary Entry ──────────────────────────────────────────────

export const glossaryEntrySchema = z.object({
  id: z.string().uuid(),
  canonicalTerm: z.string().min(1),
  translation: z.string().optional(),
  definition: z.string().optional(),
  variants: z.array(z.string()).default([]),
  sourceRefs: z.array(z.string()).default([]),
  softwareBoundary: z.string().optional(),
  addedBy: z.enum(["analysis", "user"]),
  addedAt: z.string(),
});
export type GlossaryEntry = z.infer<typeof glossaryEntrySchema>;

export const glossarySchema = z.array(glossaryEntrySchema);
export type Glossary = z.infer<typeof glossarySchema>;

// ── Code Location (terminology review findings) ────────────────

export const codeLocationSchema = z.object({
  filePath: z.string(),
  identifier: z.string(),
  line: z.number().optional(),
  suggestedRename: z.string(),
  glossaryEntryId: z.string().uuid(),
});
export type CodeLocation = z.infer<typeof codeLocationSchema>;

// ── Analysis Results ────────────────────────────────────────────

export const terminologyInconsistencySchema = z.object({
  id: z.string().uuid(),
  variants: z.array(
    z.object({
      term: z.string(),
      occurrences: z.array(
        z.object({
          source: z.string(),
          context: z.string(),
        }),
      ),
    }),
  ),
  dismissed: z.boolean().default(false),
  resolvedEntryId: z.string().uuid().optional(),
});
export type TerminologyInconsistency = z.infer<
  typeof terminologyInconsistencySchema
>;

export const terminologyAnalysisResultsSchema = z.object({
  extractedTerms: z.array(
    z.object({
      term: z.string(),
      source: z.string(),
      context: z.string(),
    }),
  ),
  inconsistencies: z.array(terminologyInconsistencySchema),
});
export type TerminologyAnalysisResults = z.infer<
  typeof terminologyAnalysisResultsSchema
>;
